<template>
  <v-sheet class="pa-2">
    <h4>Transactions</h4>
    <v-layout wrap>
      <v-flex xs12 v-for=" transaction in trx" :key="transaction.id">
        <v-layout wrap>
          <v-flex xs6 class="title">
            {{ transaction['trans-id'] }}
          </v-flex>
          <v-flex xs6 class="text-xs-right title">
            ${{ transaction['total'] }}
          </v-flex>
          <v-flex px-2 xs12 v-for="detail in transaction.details" :key="detail.registration_id">
            <v-layout>
              <v-flex xs6 :class="{'font-weight-bold': regId === detail.registration_id}">
                {{ detail.label }}
              </v-flex>
              <v-flex xs6 class="text-xs-right" :class="{'font-weight-bold': regId === detail.registration_id}">
                ${{ parseFloat(detail.amount).toFixed(2) }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-sheet>
</template>

<script>
export default {
  name: 'TransactionDetail',
  props: {
      trx: Array,
      regId: Number
  }
}
</script>

<style scoped>

</style>